<div class="row drawer-content drawer-direct-content">
    <div class="col">
        <div class="form-group"
            cdkDropList
            [cdkDropListData]="groups"
            (cdkDropListDropped)="dropped($event)">
            <div cdkDrag class="list-table determinants-table builder-table"
                *ngFor="let group of groups; let j=index;">
                <div *ngIf="j > 0"
                    class="ml-2 mb-3 mr-2">
                   <and-or [selectedItem]="group.type" (valueChanged)="groupAndOrTypeChanged($event, j)"></and-or>
                </div>
                <div class="d-flex">
                    <div class="item-mandatory d-flex flex-grow-1 flex-column"
                        cdkDropList
                        id="conditionsSelected-{{j}}"
                        [cdkDropListConnectedTo]="createConnectedTo(j)"
                        [cdkDropListData]="group.items"
                        (cdkDropListDropped)="droppedItem($event, j)">
                        <div cdkDrag *ngFor="let line of group.items; let last = last; let i=index;" class="d-flex align-items-baseline item-mandatory-item p-2">
                            <and-or [selectedItem]="line.type"
                                class="d-flex flex-shrink-1 mr-2 item-and-or"
                                (valueChanged)="conditionAndOrTypeChanged($event, j, i)"
                                *ngIf="i > 0"></and-or>
                            <span class="d-flex flex-shrink-1 mr-2 item-and-or" *ngIf="i === 0"></span>
                            <div class="determinant-element-row d-flex flex-grow-1 p-2 row">
                                <small class="m-0 col text-left">{{getLineItemName(line.lineId, "start")}}</small>
                                <div class="col text-center"><span class="badge badge-pill badge-info"><i class="fas fa-arrow-right"></i></span></div>
                                <small class="m-0 col text-right">{{getLineItemName(line.lineId, "end")}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="item-mandatory-actions d-flex flex-shrink-1 justify-content-between flex-column p-2 text-center">
                        <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-mandatory-action-delete" *ngIf="j > 0" (click)="removeGroup(j)"></i>
                        <i class="fas fa-plus btn-xs btn-outline-primary btn-icon item-mandatory-action-add mt-auto" (click)="addNewBlockAfter(group)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
